import React from 'react'
import {Button, Panel} from 'react-bootstrap'

export default class DataPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true
    };
  }

  generateErrorOrWarning() {
    const elements = [
      'feed_exported_at',
      'gs_updated_at',
      'swappa_updated_at',
      'alexa_updated_at',
      'game_retail_updated_at',
      'yp_updated_at',
      'gp_updated_at',
      'hp_updated_at',
      'samsungtv_updated_at'

    ]
    const res = {}
    elements.forEach(ele => (res[ele] = (this._getKlassName(ele) || 'default')))
    return res
  }

  _getKlassName(ele) {
    const data = this.props.data;
    switch(ele) {
      case 'feed_exported_at':
        if(data.feed.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'gs_updated_at':
        if(data.google_search.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'swappa_updated_at':
        if(data.swappa_gop.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'alexa_updated_at':
        if(data.alexa.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'game_retail_updated_at':
        if(data.game_retail.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'yp_updated_at':
        if(data.you_pass.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'gp_updated_at':
        if(data.google_play && data.google_play.delay>1) {
          return 'danger'
        }else {
          return
        }
      case 'hp_updated_at':
        if(data.hp.delay>1) {
          return 'danger'
        }else {
          return
        }
      default:
        return;
    }
  }

  _getPanelKlassName(errorOrWarning) {
    let values = Object.values(errorOrWarning)
    if(values.includes('danger')) {
      return 'danger'
    }else if(values.includes('warning')) {
      return 'warning'
    }else {
      ''
    }
  }

  render() {
    const data = this.props.data;
    const errorOrWarning = this.generateErrorOrWarning();
    const panelKlassName = this._getPanelKlassName(errorOrWarning);

    return (
      <div className='DataPanel'>
        <Panel id="collapsible-panel-example-2" defaultExpanded={this.state.open} bsStyle={panelKlassName}>
          <Panel.Heading>
            <Panel.Title toggle>
              API FEED
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <h6 className='title'>FEED EXPORT</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.feed_exported_at}`}>
                  Feed exported at :
                </dt>
                <dd className={`text-${errorOrWarning.feed_exported_at}`}>{data.feed.last_updated}</dd>
              </dl>
              <hr/>
              <h6 className='title'>HP</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.hp_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.hp_updated_at}`}>{data.hp.last_updated}</dd>
              </dl>

              <hr/>
              <h6 className='title'>SamsungGOP (SamsungTV App)</h6>
              <dl className="dl-horizontal">
                <dt>Delivered Count :</dt>
                <dd>{data.samsungtv.count}</dd>

                <dt>Last Delivery :</dt>
                <dd>{data.samsungtv.last_updated}</dd>

                <dt>S3 Files :</dt>
                <dd>Updates (Daily): {data.samsungtv.s3_files['daily']}</dd>
                <dd>Weekly Fulldump (Monday): {data.samsungtv.s3_files['weekly']}</dd>
              </dl>
              <hr/>
              <h6 className='title'>Youtube</h6>
              <dl className="dl-horizontal">
                <dt>Delivered Count :</dt>
                <dd>{data.youtube.count}</dd>

                <dt>Last Delivery :</dt>
                <dd>{data.youtube.last_updated}</dd>
              </dl>
              <hr/>
              <h6 className='title'>VMS</h6>
              <dl className="dl-horizontal">
                <dt><p className="text-info">RETAIL</p></dt><dd></dd>
                <dt>Delivered Count :</dt>
                <dd>{data.vms.retail.count}</dd>

                <dt>Last Delivery :</dt>
                <dd>{data.vms.retail.last_updated}</dd>
              </dl>

              <dl className="dl-horizontal">
                <dt><p className="text-info">ONLINE</p></dt><dd></dd>
                <dt>Delivered Count :</dt>
                <dd>{data.vms.online.count}</dd>

                <dt>Last Delivery :</dt>
                <dd>{data.vms.online.last_updated}</dd>
              </dl>
              <hr/>
              <h6 className='title'>Google Search</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.gs_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.gs_updated_at}`}>{data.google_search.last_updated}</dd>
              </dl>

              <hr/>
              <h6 className='title'>Swappa</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.swappa_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.swappa_updated_at}`}>{data.swappa_gop.last_updated}</dd>
              </dl>

              <hr/>
              <h6 className='title'>Alexa</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.alexa_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.alexa_updated_at}`}>{data.alexa.last_updated}</dd>
              </dl>

              <hr/>
              <h6 className='title'>Game Retail</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.game_retail_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.game_retail_updated_at}`}>{data.game_retail.last_updated}</dd>
              </dl>

              <hr/>
              <h6 className='title'>YouPass</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.yp_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.yp_updated_at}`}>{data.you_pass.last_updated}</dd>
              </dl>

              <hr/>
              <h6 className='title'>GooglePlay</h6>
              <dl className="dl-horizontal">
                <dt className={`text-${errorOrWarning.gp_updated_at}`}>Last Updated :</dt>
                <dd className={`text-${errorOrWarning.gp_updated_at}`}>--</dd>
              </dl>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/components/ConsumerApi/DataPanel.jsx